import { render, staticRenderFns } from "./ReservationCommentsModal.vue?vue&type=template&id=e215d42c&scoped=true&"
import script from "./ReservationCommentsModal.vue?vue&type=script&lang=js&"
export * from "./ReservationCommentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e215d42c",
  null
  
)

export default component.exports